import { connect } from "react-redux";
import { Services } from "App/ServiceLocator";
import PdfDownload from "../Components/PdfDownload";
import { setVisible } from "../reducers/Ui/Actions";

const mapStateToProps = ({ ui, Configuration }) => ({
  Component: PdfDownload,
  show: !!ui.visibilityMap.pdfDownload,
  code: Configuration.configuration ? Configuration.configuration.code : "",
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(setVisible("pdfDownload", false)),
  onOkClick: () => dispatch(setVisible("pdfDownload", false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdfDownload);
